<svg width="13" height="2" viewBox="0 0 13 2" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M1 2H12C12.3782 2 13 1.5419 13 0.994416C13 0.446928 12.3782 0 12 0H1C0.621817 0 0 0.446928 0 0.994416C0 1.5419 0.621818 2 1 2Z" fill="currentColor" fill-opacity="0.85"/>
</svg>
